/* Sea Neon — hareket katmanı: görünümde video, belirme, header kaydırma durumu, yüzen WhatsApp */
(function () {
  var io = 'IntersectionObserver' in window;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Videolar: görünüme girince oynat, çıkınca durdur
  var vids = document.querySelectorAll('video[data-sn-lazy]');
  function playVid(v) { if (v.getAttribute('preload') === 'none') v.setAttribute('preload', 'auto'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if (io && vids.length) {
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) playVid(e.target); else e.target.pause(); });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { vo.observe(v); });
  } else {
    vids.forEach(playVid);
  }

  // Hero (autoplay) videosu tarayıcı ertelerse tekrar dene
  document.querySelectorAll('video[autoplay]').forEach(function (v) {
    var kick = function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
    v.addEventListener('loadeddata', kick); v.addEventListener('canplay', kick); setTimeout(kick, 1500); setTimeout(kick, 4000);
  });

  // Belirme: görünüme yaklaşınca .is-in; JS yoksa ya da hareket azaltılmışsa hepsi açık
  var rev = document.querySelectorAll('[data-sn-reveal]');
  function revealAll() { rev.forEach(function (el) { el.classList.add('is-in'); }); }
  if (io && rev.length && !reduce) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 18% 0px', threshold: 0.01 });
    rev.forEach(function (el) { ro.observe(el); });
    // Güvenlik ağı: 6 sn sonra hâlâ gizli kalan hiçbir şey olmasın
    setTimeout(revealAll, 6000);
  } else {
    revealAll();
  }

  // Header: 40px sonra dolu zemin · yüzen WhatsApp 400px sonra
  var header = document.querySelector('header.sn-header');
  var fab = document.querySelector('.sn-fab');
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (header) header.classList.toggle('is-scrolled', y > 40);
    if (fab) fab.classList.toggle('is-on', y > 400);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // Açılır menüler: dışarı tıklayınca kapan
  document.addEventListener('click', function (ev) {
    document.querySelectorAll('details.sn-dd[open]').forEach(function (d) {
      if (!d.contains(ev.target)) d.removeAttribute('open');
    });
  });
})();
